import {
    CERTIFICATE_ADD_PAGE_LOADED,
    CERTIFICATE_ADD_PAGE_UNLOADED,
    CERTIFICATE_ADD,
    CERTIFICATE_LIST_PAGE_LOADED,
    CERTIFICATE_LIST_PAGE_UNLOADED,
    CERTIFICATE_DETAIL_PAGE_LOADED,
    CERTIFICATE_DETAIL_PAGE_UNLOADED,
    ISSUER_DETAIL_PAGE_LOADED,
    ISSUER_DETAIL_PAGE_UNLOADED,
    ISSUER_UPDATE,
    ISSUER_DETAIL_LOGS_LOADED,
    ACCOUNT_SUBSCRIBE,
    CERTIFICATE_FILE_UPLOADED,
    CERTIFICATE_PENDING_LIST_PAGE_LOADED,
    CERTIFICATE_PENDING_LIST_PAGE_UNLOADED,
    CERTIFICATE_BULK_CREATE,
    REMOVE_PENDING_CERTIFICATE,
    CLEAR_CERTIFICATE_ADD_PROPS
} from '../constants/actionTypes';
import { REACT_APP_PAGESIZE } from '../constants/config'
export default (state = {}, action) => {
    switch (action.type) {
        case CERTIFICATE_ADD:
            return {
                ...state,
                nextStep: action.nextStep,
                errors: action.error ? action.payload.error : null,
            };
        case CLEAR_CERTIFICATE_ADD_PROPS:
            return {
                ...state,
                nextStep: null,
            };
        case CERTIFICATE_DETAIL_PAGE_LOADED:
            return {
                ...state,
                certificate: action.error ? null : action.payload,
            }
        case CERTIFICATE_LIST_PAGE_LOADED:
            return {
                ...state,
                certificates: action.error ? null : action.payload.certificates,
            }
        case ISSUER_DETAIL_PAGE_LOADED:
            return {
                ...state,
                issuer: action.error ? null : action.payload[0],
                logs: action.error ? null : action.payload[1].logs,
                totalCount: action.payload[1].totalCount,
                currentPage: action.currentPage,
                totalPage: Math.ceil((action.payload[1].totalCount || 0) / REACT_APP_PAGESIZE)
            }
        case ISSUER_DETAIL_LOGS_LOADED:
            return {
                ...state,
                logs: action.error ? null : action.payload.logs,
                totalCount: action.payload.totalCount,
                currentPage: action.currentPage,
                totalPage: Math.ceil((action.payload.totalCount || 0) / REACT_APP_PAGESIZE),
                updated: false
            }
        case ISSUER_UPDATE:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                updated: action.error ? false : true
            };
        case CERTIFICATE_ADD_PAGE_UNLOADED:
        case CERTIFICATE_LIST_PAGE_UNLOADED:
        case CERTIFICATE_DETAIL_PAGE_UNLOADED:
        case ISSUER_DETAIL_PAGE_UNLOADED:
        case CERTIFICATE_PENDING_LIST_PAGE_UNLOADED:
            return {};
        case ACCOUNT_SUBSCRIBE:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
            };
        case CERTIFICATE_FILE_UPLOADED:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                upload_response_received: action.payload ? true : false,
                upload_response: action.error ? null : action.payload,
            };
        case CERTIFICATE_PENDING_LIST_PAGE_LOADED:
            return {
                ...state,
                pending_certificates: action.error ? null : action.payload.pending_certificates,
            }
        case CERTIFICATE_BULK_CREATE:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
            };
        case REMOVE_PENDING_CERTIFICATE:
            const id = action.key
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                pending_certificates: state.pending_certificates ? state.pending_certificates.filter(item => item.key !== id) : [],
            };
        default:
            return state;
    }
};
